import { Component } from '@angular/core';
import { soundpostOrderLineEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Order Lines') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostorderline-form',
    templateUrl: './soundpostorderline.form.component.html'
})
export class soundpostOrderLineFormComponent extends BaseFormComponent {
    public record!: soundpostOrderLineEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'orderLines', sectionName: 'Order Lines', isExpanded: false },
            { sectionKey: 'accountingSchedules', sectionName: 'Accounting Schedules', isExpanded: false },
            { sectionKey: 'paymentLines', sectionName: 'Payment Lines', isExpanded: false }
        ]);
    }
}

